module.exports = __webpack_public_path__ + "img/39_38.696acdaf.png";